import { useMutation } from 'react-admin';

import { useNotifyError } from '../../../../utils/notifiers/useNotifyError';
import { OrderDocumentOutputType } from '../../../../entities';

export const useDocumentMutation = (resource, recordId, documentsPath, fetchAllDocuments) => {
	const notifyError = useNotifyError();
	const [mutate] = useMutation(
		{
			resource: `${resource}/${recordId}/${documentsPath}`,
		},
		{
			onSuccess: fetchAllDocuments,
			onFailure: error => {
				notifyError(error);
			},
		}
	);

	const deleteDocument = doc => {
		if (documentsPath === 'documents-output') {
			if (doc.type === OrderDocumentOutputType.loading) {
				// props.changeIsLoading(false)
			} else if (doc.type === OrderDocumentOutputType.unloading) {
				// props.changeIsUnloading(false)
			}
		}
		if (!window.confirm('Are you sure to delete this document?')) return;
		mutate({
			type: 'delete',
			payload: {
				id: doc.id,
			},
		});
	};

	const updateDocument = doc => {
		mutate({
			type: 'update',
			payload: {
				id: doc.id,
				data: {
					title: doc.title,
					type: doc.type,
				},
			},
		});
	};

	return { deleteDocument, updateDocument };
};
